export const formatDateTime = (date: string | null | undefined) => {
    if (!date) return '-';
   try {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(date));
     } catch (error) {
        console.error('Error while formatting date', error);
        return '-';
      }
};
